module.exports = __webpack_public_path__ + "static/media/woman-supervillain_1f9b9-200d-2640-fe0f.3a647c06.png";